// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2VgBL","list":"BalanceDue_list__1qh1h","listRow":"BalanceDue_listRow__1S4bN","total":"BalanceDue_total__OVf9r"};